import React from 'react';

import { IconWrapper } from '../styled-components';

import { ReactComponent as Money } from './money-icon.svg';
import { ReactComponent as MoneyDark} from './money-icon-dark.svg';
import styled from "styled-components";

const StyledITSpendIcon = styled(Money)`
  
`

const StyledITSpendIconDark = styled(MoneyDark)`
  
`

type ITSpendIconProps = {
  /**
   * Scale the icon relative to a base size of 2rem
   */
  scale?: number;
  /**
   * An alternative text that is read by a screen reader for accessibility purposes.
   */
  altText: string;
  /* light or dark mode*/
  light?: boolean;
  theme:any;
};

const ItSpendIcon: React.FC<ITSpendIconProps> = ({ scale = 1, altText, light ,theme}) => {
  return (
    <IconWrapper width={2 * scale} height={2 * scale} aria-label={altText}>
      {theme==="light" ? <StyledITSpendIcon /> : <StyledITSpendIconDark />}
    </IconWrapper>
  );
};

export default ItSpendIcon;